import { Component, OnInit } from '@angular/core';
import { CardComponent } from '@shared/components/card/card.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { ThemeService } from '@app/core/services/theme.service';
import { ToggleComponent } from '@shared/components/input/toggle/toggle.component';
import { PreferencesService } from '@app/core/services/preferences.service';
import { CollapseService } from '@app/core/services/collapse.service';
import { UserService } from '@app/core/services/user.service';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { roleTableConfig } from '@shared/table-configs/settings/role.table';

@Component({
  selector: 'app-settings-profile',
  imports: [
    CardComponent,
    TranslatePipe,
    FormsModule,
    ToggleComponent,
  ],
  templateUrl: './settings-profile.component.html',
  styleUrl: './settings-profile.component.css'
})
export class SettingsProfileComponent implements OnInit {

  public floatingHeader: boolean = false;
  public collapse: boolean = false;
  public dashboardComputedGridloss: boolean = false;
  public tableConfig: TableConfig<any> = roleTableConfig;
  public tableRoles: any[] = [];

  constructor(
    public readonly userService: UserService,
    public readonly themeService: ThemeService,
    private readonly translateService: TranslateService,
    private readonly collapseService: CollapseService,
    private readonly preferencesService: PreferencesService,
  ) {}

  public ngOnInit(): void {
    this.collapse = this.collapseService.collapsed();
    this.floatingHeader = this.preferencesService.floatingHeader();
    this.dashboardComputedGridloss = this.preferencesService.dashboardComputedGridloss();

    const user = this.userService.user();
    if (user) {
      const roles = [...user.roles];

      if (roles && roles.length > 0) {
        roles.sort((a: string, b: string) => (a > b ? 1 : -1));
        this.tableRoles = roles.map((role: string) => ({
          role: role,
          description: this.translateService.instant(`role.${role.toLowerCase()}.description`)
        }));
      }
    }
  }

  public onFloatingHeaderChange(enabled: boolean): void {
    this.preferencesService.setFloatingHeader(enabled);
  }

  public onDashboardComputedGridlossChange(enabled: boolean): void {
    this.preferencesService.setDashboardComputedGridloss(enabled);
  }
}
